import { DropdownOption } from '@urbanx/agx.ui-components2';
import { LicenceDetailsState } from '@urbanx/agx.agencies.client';

export const allStateOptions: DropdownOption[] = Object.values(LicenceDetailsState).map((state) => {
  return {
    value: state.toString(),
    label: state.toString(),
  };
});
